import { render } from "./Footer.vue?vue&type=template&id=2d1ec8ba&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2d1ec8ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Florian\\Desktop\\FeuerwehrWeb3\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1ec8ba"]])

export default __exports__